import React from 'react';
import styled from 'styled-components';
import { Box, Container, Flex } from '@components/layout/Grid';
import BaseSkeleton from '@skeletons/BaseSkeleton';
import ButtonSkeleton from '@skeletons/ButtonSkeleton';

const Thumbnail = styled(BaseSkeleton)`
  height: 100%;
  min-height: 100%;
  aspect-ratio: 2;
`;

const ProgressPageSkeleton = () => (
  <Container
    key="ProgressPageSkeleton"
    pt="50px"
    pb="50px"
    px={[25, 25, 20]}
    flexWrap="wrap"
    alignItems="center"
  >
    <Box flex={1} mr="10px" key="ProgressPageSkeleton--Box">
      <Thumbnail shape="square" />
    </Box>
    <Box flex={1} ml="10px" mr={[0, 0, 20]} key="ProgressPageSkeleton--Box">
      <Flex flexWrap="wrap" mb={20}>
        <ButtonSkeleton width={70} />
        <Box ml={20} flex="0 0 108px">
          <BaseSkeleton shape="square" height={26} />
        </Box>
      </Flex>
      <Box py={'30'}>
        <BaseSkeleton shape="square" width={50} height={30} marginBottom={15} />
        <BaseSkeleton shape="square" height={80} marginBottom={25} />
        <BaseSkeleton shape="square" height={25} width={40} />
      </Box>
    </Box>
  </Container>
);

export default ProgressPageSkeleton;
